import { createActions } from 'redux-actions';

export const actions = createActions({
  MEETING: {
    SEND_FEEDBACK: (payload) => payload,
  },
}).meeting;
